/**
 * Created by Jan on 18.09.2016.
 */

//TODO MOBA II - move this class and the loading animator to Lfl.Animations namespace.
(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.AsynchronousLoading;

    (function (AsynchronousLoading, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.AsynchronousLoading, 'ElementLoadingAnimationHandler')) {
            return;
        }

        /*
         |===========================================================================================================
         | Class definition
         |===========================================================================================================
         */

        /**
         * Encapsulates the actions associated with handling a loading animation triggered by specific element.
         *
         * Examples of type:
         *       {
         *          name: 'prependLoadingSpinner',
         *          $target: $elementInsideThe$ElementThatShouldBePrependedWithLoadingSpinner,
         *          [font]: 'bts or other black tie font'
         *        }
         *        TODO MOBA II - use an enum class? Or more likely, create multiple animation handlers.
         *             Upd: Seems confirmed to be a good idea by the separation of the ElementLoadingSpinnerAnimator.
         * @memberOf Lfl.AsynchronousLoading
         * @lends Lfl.AsynchronousLoading.ElementLoadingAnimationHandler
         * @param {jQuery} $element
         * @param {object} type
         * @param {string} type.name One of {name: 'showBackdrop'} and the {name: 'prependLoadingSpinner'} see the example.
         * @param {jQuery} type.$target
         * @param {string} type.font
         * @param {string} type.icon
         * @constructor
         */
        Lfl.AsynchronousLoading.ElementLoadingAnimationHandler = function ($element, type) {

            // TODO MOBA II - move to the enum.
            var SHOW_BACKDROP_NAME = 'showBackdrop';
            var LOADING_SPINNER_NAME = 'prependLoadingSpinner';
            /*
             |-------------------------------------------------------------------------------------------------------------------
             | Construction
             |-------------------------------------------------------------------------------------------------------------------
             */

            // TODO MOBA II - refactor this. Used to be "showBackdrop/nothing" - find usages of setShowBackdrop and
            // only use the type.
            var showBackdrop = false;
            var spinnerAnimator;

            if (typeof type === 'undefined') {
                type = {
                    name: SHOW_BACKDROP_NAME
                }
            }

            switch (type.name) {
                case SHOW_BACKDROP_NAME:
                    showBackdrop = true;
                    break;

                case LOADING_SPINNER_NAME:
                    spinnerAnimator = new Lfl.Animations.ElementLoadingSpinnerAnimator({
                        $element: $element,
                        $target: type.$target,
                        icon: type.icon
                    });

                    break;

                default:
                    throw "Unknown type " + type.name;
            }


            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             *
             * @param {boolean} shouldShowBackdrop Whether all other action should be disabled for the loading duration.
             * If so, then backdrop loading animation over the entire screen will prevent any user action.
             * @returns {Lfl.AsynchronousLoading.ElementLoadingAnimationHandler}
             */
            this.setShowBackdrop = function (shouldShowBackdrop) {
                showBackdrop = shouldShowBackdrop;
                return this;
            };

            /**
             * TODO MOBA II - rename to startAnimation
             * Animates an element that has triggered some form of loading action.
             */
            this.animateElement = function () {
                $element.prop('disabled', true);

                // And hide any elements that should be hidden.
                $element.tooltip('hide');
                $element.popover('hide');

                if (showBackdrop) {
                    LoadingAnimator.showLoadingBackdrop();
                }

                if (type.name === LOADING_SPINNER_NAME) {
                    spinnerAnimator.start();
                }
            };

            /**
             * TODO MOBA II - rename to stopAnimation
             * Notifies the animator that the loading is finished.
             */
            this.loadingFinishedCallback = function () {
                if (showBackdrop) {
                    LoadingAnimator.showLoadingBackdrop();

                    setTimeout(function () {
                        $element.prop('disabled', false);
                        if (showBackdrop) {
                            LoadingAnimator.hideLoadingBackdrop();
                        }
                    }, LoadingAnimator.DEFAULT_BACKDROP_HIDING_DELAY);
                }

                if (type.name === LOADING_SPINNER_NAME) {
                    spinnerAnimator.stop();
                }
            };
        };

        /*
         |---------------------------------------------------------------------------------------------------------------
         | Static members
         |---------------------------------------------------------------------------------------------------------------
         */

        // TODO MOBA II - refactor to that enum...
        /**
         * Provides the basic spinner type for the animation handler instance.
         * @param $element
         * @returns {{name: string, $target: *, font: string}}
         */
        Lfl.AsynchronousLoading.ElementLoadingAnimationHandler.getSpinnerType = function ($element) {
            return {
                name: 'prependLoadingSpinner',
                $target: $element
            }
        };


    }(Lfl.AsynchronousLoading = Lfl.AsynchronousLoading || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
